import React, { useEffect, useState } from 'react'
import SharedPostContent from './SharedPostContent';
import SharedPostHeader from './SharedPostHeader';
import { useDispatch } from 'react-redux';
import { setError, setMessage } from '../../../../../../store/common/generalSlice';
import usePostApi from '../../../../../../config/hooks/api/post/usePostApi';
import { Link, useLocation, useNavigate, useParams } from 'react-router-dom';
import { Card, Col, Input, Row, Spin } from 'antd';
import { LoadingOutlined } from '@ant-design/icons';
import { FaChevronLeft } from 'react-icons/fa';
import Button from '../../../../../../components/FormElements/Button';


const SharedPost = (props) => {
    const { postId } = useParams();
    const location = useLocation()
    const dispatch = useDispatch()
    const navigate = useNavigate()
    const { getPostById: getPostDetailsById, sharePost } = usePostApi()

    const [postData, setPostData] = useState(null)
    const [loading, setLoading] = useState(false)
    const [shareDescription, setShareDescription] = useState('')

    const getPostById = async () => {
        try {
            if(location){
                if (!postId) {
                    dispatch(setError('Required Post Id'))
                    return
                }
                const response = await getPostDetailsById(postId)
                if (response) {
                    setPostData(null)
                    setPostData(response?.data?.post)
                }
            }
        } catch (error) {
            console.log(error)
        }
    }

    const getPostData = async () => {
        try {
            if (!props?.data) await getPostById()
            else setPostData(props?.data)

        } catch (error) {
            console.log(error)
        }
    }

    const handleSharePost = async () => {
        try {
            // if(values){
                // const { shareDescription } = values
                if(!postId){
                    dispatch(setError('Something went wrong'))
                    return
                }
                
                const response = await sharePost({shareDescription}, postId)
                if (response) {
                    dispatch(setMessage(response?.data?.message))
                    navigate('/posts') 
                }
            // }
        } catch (error) {
            console.log(error)
        }
    }

    const refreshFeed = async () => await getPostById()

    const handleShareDescription = (e) => {
        setShareDescription(e.target.value)
    }

    useEffect(() => {
        setLoading(true)
        getPostData()
    }, [])

    useEffect(() => {
        // setTimeout(() => {
            setLoading(false)
        // }, 2000);
    }, [postData])


    return (
        <Row>
            <Col 
                md={24} sm={24} xs={24} 
                className={`${!props.data && 'md:px-20 sm:px-20 md:pt-6 sm:pt-6 px-2 pt-6'}`}
            >
                { !props.data && (
                <div className='flex justify-between items-center mb-4'>
                    { location && location?.pathname.toLowerCase().includes('share') ? (
                    <div>
                        <h5 className='heading-5 font-bold mb-0'>Share Post</h5>
                    </div>
                    ) : ''}
                    <Link to='/posts' className='cursor-pointer flex items-center'>
                        <FaChevronLeft className='text-primary bg-white p-2 rounded-full text-3xl' />
                        <small className='ml-2 font-medium'>Back</small>
                    </Link>
                </div>
                )}
                <Card bordered={false} className='p-0 post mb-4 rounded border-2'>
                    { postId && location && location?.pathname.toLowerCase().includes('share') && (
                    <Input 
                        placeholder="What's on your mind?" 
                        name='shareDescription' 
                        value={shareDescription} 
                        onChange={handleShareDescription} 
                        className='mb-6 pl-0'
                        variant="borderless"
                    />
                    ) }
                    <React.Fragment>
                        {loading ? (
                            <Spin indicator={<LoadingOutlined className='text-black' spin />} size="medium" />
                        ) : (
                            <div 
                                className={`${postId && location && location?.pathname.toLowerCase().includes('share') && 'border-2 p-4 rounded-md'}`}>
                                <SharedPostHeader data={postData} />
                                <SharedPostContent data={postData} refreshFeed={refreshFeed} />
                            </div>
                        )}
                    </React.Fragment>
                </Card>
                { location && location?.pathname.toLowerCase().includes('share') && (
                    <div className='flex justify-end'>
                        <Button.Basic
                            onClick={handleSharePost}
                            disabled={false}
                            icon={null}
                            loading={false}
                            type="primary"
                            size='small'
                            text='Post'
                            className='btn-primary md:w-fit sm:w-fit w-full'
                        />
                    </div>
                )}
            </Col>
        </Row>
    )
}

export default SharedPost